/* eslint-disable */
import React from "react";
import RichTextEditor, { BaseKit } from "reactjs-tiptap-editor";
import { Blockquote } from "reactjs-tiptap-editor/blockquote";
import { Bold } from "reactjs-tiptap-editor/bold";
import { BulletList } from "reactjs-tiptap-editor/bulletlist";
import { Code } from "reactjs-tiptap-editor/code";
import { Color } from "reactjs-tiptap-editor/color";
import { FontSize } from "reactjs-tiptap-editor/fontsize";
import { Heading } from "reactjs-tiptap-editor/heading";
import { Highlight } from "reactjs-tiptap-editor/highlight";
import { History } from "reactjs-tiptap-editor/history";
import { HorizontalRule } from "reactjs-tiptap-editor/horizontalrule";
import { Image } from "reactjs-tiptap-editor/image";
import { Italic } from "reactjs-tiptap-editor/italic";
import { LineHeight } from "reactjs-tiptap-editor/lineheight";
import { Link } from "reactjs-tiptap-editor/link";
import { ListItem } from "reactjs-tiptap-editor/listitem";
import { OrderedList } from "reactjs-tiptap-editor/orderedlist";
import { Selection } from "reactjs-tiptap-editor/selection";
import { SlashCommand } from "reactjs-tiptap-editor/slashcommand";
import { Strike } from "reactjs-tiptap-editor/strike";
import { SubAndSuperScript } from "reactjs-tiptap-editor/subandsuperscript";
import { Table } from "reactjs-tiptap-editor/table";
import { TaskList } from "reactjs-tiptap-editor/tasklist";
import { TextAlign } from "reactjs-tiptap-editor/textalign";
import { TextBubble } from "reactjs-tiptap-editor/textbubble";
import { TextUnderline } from "reactjs-tiptap-editor/textunderline";
import { TrailingNode } from "reactjs-tiptap-editor/trailingnode";

const PostEditorView = props => {
  const { content } = props;
  const extensions = [
    BaseKit.configure({
      placeholder: false,
      characterCount: false,
    }),
    History,
    Bold,
    Italic,
    TextUnderline,
    Color,
    Heading,
    FontSize,
    LineHeight,
    Highlight,
    TextAlign,
    Blockquote,
    Link,
    ListItem,
    BulletList,
    OrderedList,
    Code,
    Selection,
    SlashCommand,
    Strike,
    SubAndSuperScript,
    TaskList,
    HorizontalRule,
    Image,
    TextBubble,
    TrailingNode,
    Table,
  ];

  const customOptions = {
    editable: false,
  };

  return (
    <div className="eventsPost-editor">
      <RichTextEditor
        content={content}
        extensions={extensions}
        useEditorOptions={customOptions}
        dark={true}
        hideBubble={true}
        hideToolbar={true}
        disabled={true}
        disableBubble={true}
        toolbar={false}
        dense={true}
      />
    </div>
  );
};

export default PostEditorView;
